// Google Analytics utility functions

/**
 * Track a page view in Google Analytics
 * @param {string} url - The URL to track
 */
export const pageview = (url) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", "G-88CJC07H2N", {
      page_path: url,
    });
  }
};

/**
 * Track a custom event in Google Analytics
 * @param {string} action - The action to track (e.g., 'click', 'submit')
 * @param {object} params - Additional parameters to track
 */
export const event = ({ action, params }) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, params);
  }
};
